export default {
      id: "exclamation-triangle-usage",
      viewBox: "0 0 576 512",
      url: __webpack_public_path__ + "img/icons.a60dffc6.svg#exclamation-triangle",
      toString: function () {
        return this.url;
      }
    }